import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
    EnvironmentPicker,
    validateEnvironmentPickerValidation,
} from './EnvironmentPicker';

export const EnvironmentPickerExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
        name: 'EnvironmentPicker',
        // @ts-ignore
        component: EnvironmentPicker,
        validation: validateEnvironmentPickerValidation,
    }),
);
